import React, { Component } from "react";
import { Container } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import DevicesStatistics from "components/monitor/resume/DevicesStatistics";
import NetworkStatistics from "components/monitor/resume/NetworkStatistics";
import TrafficStatistics from "components/monitor/resume/TrafficStatistics";

export class Resume extends Component {
  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
  }

  render() {
    return (
      <Container style={containerStyle}>
        <DevicesStatistics />
        <NetworkStatistics />
        <TrafficStatistics />
      </Container>
    );
  }
}

const containerStyle = {
  "marginTop": "8vh",
  "width": "850px",
};

export default withRouter(Resume);